import React from "react";
import { SvgProps } from "../../types";

export const EventsPageIcon = (props: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      className={`${props.classNames?.join(" ") || ""}`}
    >
      <path
        d="M12 5.365V3M12 5.365C13.3851 5.4182 14.6952 6.00811 15.6532 7.00992C16.6111 8.01174 17.1418 9.34691 17.133 10.733V12.533C17.133 14.919 19 15.515 19 16.708C19 17.301 19 17.901 18.462 17.901H5.53803C5.00003 17.901 5.00003 17.301 5.00003 16.708C5.00003 15.515 6.86703 14.919 6.86703 12.533V10.733C6.85822 9.34691 7.38892 8.01174 8.34688 7.00992C9.30484 6.00811 10.6149 5.4182 12 5.365ZM3.86603 10.733C3.87421 8.61344 4.67791 6.57421 6.11803 5.019M20.134 10.733C20.1258 8.61344 19.3221 6.57421 17.882 5.019M8.54003 17.901C8.63193 18.7545 9.03606 19.5439 9.67474 20.1175C10.3134 20.6911 11.1416 21.0084 12 21.0084C12.8585 21.0084 13.6866 20.6911 14.3253 20.1175C14.964 19.5439 15.3681 18.7545 15.46 17.901H8.54003Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
